import { FC } from "react";
import Contact from "./components/contact/Contact.tsx";
import Socials from "./components/socials/Socials.tsx";
import { Container, Row } from "react-bootstrap";
import styles from './Footer.module.scss';

const Footer: FC = () => {
    return (
        <footer
            className={`bg-dark py-5 ${styles.footer}`}
        >
            <Container>
                <Row
                    className={`d-flex justify-content-between ${styles.footerRow}`}
                >
                    <Contact />
                    <Socials />
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;